import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import Loader from "./../../shared/loader";
import Onboarding from '../../shared/onboarding/onboarding';
import {
  fetchVisualEffect,
  assignScenesToVisualEffect,
  clearRedirect,
  fetchAllScenes,
  fetchAllCharacters,
  fetchAllSceneSettings,
  fetchScenesAssignedToProp,
  findInScript,
  clearSceneSearchResults,
  setSceneAssignedToVisualEffect
} from "./ducks/actions";
import Form from "./scenes-form";
import {
  searchScenes,
  SEARCH_SCENES_FOR_PROPS,
  SEARCH_SCENES_FOR_VISUAL_EFFECTS
} from "../scenes/search/ducks/actions";
import SearchScenesForm from "../scenes/search/search-scenes-form";
import ScriptSearch from "../script/search/script-search";
import { OnboardingStep1ClassName, OnboardingStep2ClassName } from './ducks/reducer';

function PropScenes(props) {
  const visualEffectId = props.visualEffectId || props.match.params.visualEffectId;
  const filmId = props.filmId || props.match.params.filmId;
  const {
    prop,
    fetchAllScenes,
    fetchProp,
    fetchAllCharacters,
    fetchAllSceneSettings,
    fetchScenesAssignedToProp,
    assignScenesToProp,
    setSceneAssignedToProp,
    loadingProp,
    allScenes,
    searchScenes,
    findInScript,
    clearSceneSearchResults,
    errors,
    readOnly,
    sceneId,
    embedded,
    onboardingSteps,
    loadingSceneSettings,
    findingInScript,
    searchingScenes
  } = props;

  const invalidIds = ["add", "scenes"];

  // const allSelectedScenes = (props.selectedSceneIds || []).concat(
  //   props.searchedScenes?.map((s) => s.id)
  // );

  useEffect(() => {
    fetchProp(filmId, visualEffectId);
    fetchAllScenes(filmId);
    fetchAllCharacters(filmId);
    fetchAllSceneSettings(filmId);
    if (!sceneId) {
      fetchScenesAssignedToProp(filmId, visualEffectId);
    }
  }, [filmId, visualEffectId]);

  useEffect(() => {
    if (sceneId) {
      setSceneAssignedToProp(sceneId);
    }
  }, [sceneId]);

  if (!embedded && props.redirect) {
    if (props.redirect.to === "list") {
      props.clearRedirect();
      const url = `/films/${filmId}/visual-effects/`;
      return <Redirect to={url} />;
    } else {
      props.clearRedirect();
      return <Redirect to={props.redirect.to} />;
    }
  }

  const onFindInScript = (e) => {
    e.preventDefault();
    findInScript(filmId, prop.name);
  };

  if (invalidIds.indexOf(visualEffectId) > -1) {
    return null;
  }

  function renderLoading() {
    return <Loader />;
  }

  function renderForm() {
    return (
      <div className="blade-content">
        <h2 className="menu-label">Visual Effects Scenes</h2>

        {!readOnly && <div className={`box mt-1 ${OnboardingStep1ClassName}`}>
          <SearchScenesForm
            errors={errors}
            mode="edit"
            filmId={filmId}
            visualEffectId={visualEffectId}
            loading={loadingProp}
            onSubmit={onSearchScenes}
            findInScript={onFindInScript}
            allCharacters={props.allCharacters}
            allSceneSettings={props.allSceneSettings}
            propName={prop?.name}
            searchingScenes={searchingScenes}
            scenes={allScenes}
            showCharacters={true}
            showScriptDays={false}
            showSceneSettings={true}
          />
        </div>}
        {!readOnly && <div className={`box mt-1 ${OnboardingStep2ClassName}`}>
          <ScriptSearch filmId={filmId} text={prop?.name} typeToDispatch="VISUAL_EFFECTS_SEARCH_SCRIPT" findingInScript={findingInScript} />
        </div>}
        <Form
          errors={errors}
          mode="edit"
          filmId={filmId}
          propId={visualEffectId}
          initialValues={{ selectedSceneIds: props.selectedSceneIds }}
          loading={loadingSceneSettings || loadingProp}
          onSubmit={onUpdatePropScenes}
          reduxFormValues={props.reduxFormValues}
          allScenes={props.allScenes}
          searchedSceneIds={props.searchedScenes?.map((s) => s.id)}
          selectSearchedScenes={props.selectSearchedScenes}
          clearSceneSearchResults={clearSceneSearchResults}
          readOnly={readOnly}
        />
        <Onboarding onboardingSteps={onboardingSteps} section="Visual Effects Scenes" />
      </div>
    );
  }

  function onSearchScenes(params) {
    searchScenes(
      SEARCH_SCENES_FOR_VISUAL_EFFECTS,
      filmId,
      params
    );
  }

  function onUpdatePropScenes(propScenes) {
    assignScenesToProp(filmId, visualEffectId, propScenes.selectedSceneIds);
  }

  return allScenes?.length ? renderForm() : renderLoading();
}

function mapStateToProps(state) {
  const { visualEffectsState, form } = state;
  return {
    prop: visualEffectsState.prop,
    allScenes: visualEffectsState.scenes,
    allCharacters: visualEffectsState.characters,
    allSceneSettings: visualEffectsState.sceneSettings,
    selectedSceneIds: visualEffectsState.selectedSceneIds,
    loadingSceneSettings: visualEffectsState.loadingSceneSettings,
    readOnly: visualEffectsState.readOnly,
    searchedScenes: visualEffectsState.searchedScenes,
    selectSearchedScenes: visualEffectsState.selectSearchedScenes,
    findingInScript: visualEffectsState.findingInScript,
    searchingScenes: visualEffectsState.searchingScenes,
    errors: visualEffectsState.errors,
    redirect: visualEffectsState.redirect,
    onboardingSteps: visualEffectsState.onboardingSteps,
    reduxFormValues: form?.propScenesForm?.values
  };
}

export default
  connect(mapStateToProps, {
    fetchProp: fetchVisualEffect,
    fetchAllScenes,
    fetchAllCharacters,
    fetchAllSceneSettings,
    fetchScenesAssignedToProp,
    clearRedirect,
    assignScenesToProp: assignScenesToVisualEffect,
    searchScenes,
    findInScript,
    clearSceneSearchResults,
    setSceneAssignedToProp: setSceneAssignedToVisualEffect
  })(PropScenes);
